import styled from 'styled-components'
import { rem, media } from '../../utils'

const CtaBtn = styled.a`
  background: #ff4856;

  padding: ${rem(16)} ${rem(20)};
  padding-top: ${rem(19)};
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: ${rem(9)};
  text-align: center;
  border-radius: ${rem(5)};
  font-family: 'Basis Bold';
  text-transform: uppercase;
  letter-spacing: 0.2rem;
  border: ${({ isSticky, background }) =>
    isSticky || background ? '1px solid #ff4856' : '1px solid white'};

  transition: 0.2s background ease-in-out;

  ${media.tablet`
    font-size: ${rem(12)};
    background: ${({ isSticky, background }) =>
      isSticky || background ? '#ff4856' : 'rgba(255,255,255,0)'};

    &:hover {
      background: #DF3F4B;
    }
  `};
`

export default CtaBtn
